module.exports = __webpack_public_path__ + "img/analisis.565aedff.png";